import { Row, Col } from "react-bootstrap";
import styles from "./AboutDeliveryBizConnect.module.css";

function AboutDeliveryBizConnectProposal() {
  return (
    <Row className={styles.ContentContainer}>
      <Col className="d-flex align-items-center">
        <div>
          <div className={styles.makeProposalTitle}>About this Proposal</div>
          <div className={styles.makeProposalSubtext}>
            DeliveryBizConnect saves restaurants $18,315.90 per year on pickup & delivery fees with our FREE Pickup & 3.33% delivery fee online & mobile ordering platform including mobile app branded to the restaurant. Our auto data collection and restaurant CRM can help increase restaurant sales 23% within 6 months. Implementing our system allows restaurants to stop using the 30% of order 3rd party delivery apps and NOT lose sales.
            <br /><br />
            We are looking for funding to scale and help 10,000 restaurants start saving over the 30% fee third party apps withing the next 10 months.  Restaurants have been beaten up through covid and need our help.
            <br /><br />
            Tech stack is complete including:
            Order Handling Tablet App
            Driver Mobile App
            Discount Food Customer App
            DBC Share Mobile App
            Restaurant CRM Mobile/web
            To date, just over $6,000,000 spent in software and marketing development
            <br /><br />
            Our Marketing assets include:
            Website – 71 pages
            Blog – 85 articles
            Sales Funnels – 127 landing pages, 102 Surveys, 464 emails/SMS follow up
            YouTube Videos - 85
            Database – 3975 Restaurants 2652 Drivers.
            <br /><br />
            Average Savings for Restaurants with DeliveryBizConnect
            <br />
            $5.00 / Order
            $1526.33 / Month
            $18,315.90 per year
            Based on 75 Orders/Week | $30 Avg. Order | 15% Avg. Tip
          </div>
          <br /><br />
        </div>
      </Col>
    </Row>
  );
}

export default AboutDeliveryBizConnectProposal;

